/** Ask: a question in words, answered from the recordings themselves. */
const en = {
  title: 'Ask',
  subtitle:
    'Ask about your recordings in plain language. The answer is read from your sessions, errors and tickets, never from memory.',
  examplesTitle: 'Try one of these',
  examples: [
    'How many errors did ayse@example.com hit in the last month?',
    'Which users struggled most this week?',
    'What is the most common error right now, and who did it affect?',
    'Show me the sessions that gave up on checkout yesterday.',
  ],
  placeholder: 'Ask about a user, an error, or a week…',
  send: 'Ask',
  thinking: 'Reading your data…',
  writing: 'Writing the answer…',
  workedFrom: 'Worked from:',
  failed: 'The question could not be answered. Try again, or check Admin → AI & Models.',
  exhausted:
    'This answer is partial: the question needed more lookups than one run allows. Narrow it down and ask again.',
  scope:
    'Only this organization’s data is reachable, and only what your own role allows. Answers can be wrong; the tools listed under each one are what it actually read.',
  history: 'Conversations',
  newChat: 'New conversation',
  noHistory: 'Your questions are kept here, visible only to you.',
  delete: 'Delete conversation',
  deleteConfirm: 'Delete this conversation? This cannot be undone.',
  notFound: 'This conversation no longer exists.',
  tools: {
    list_projects: 'Listing projects',
    search_sessions: 'Searching sessions',
    user_activity: 'Reading user activity',
    get_session: 'Opening a session',
    get_session_steps: 'Reading session steps',
    most_frustrated_sessions: 'Finding frustrated sessions',
    list_error_groups: 'Listing errors',
    get_error_group: 'Opening an error',
    list_tickets: 'Listing tickets',
    get_ticket: 'Opening a ticket',
    create_ticket: 'Creating a ticket',
    analytics_overview: 'Reading analytics',
  } as Record<string, string>,
};

const tr: typeof en = {
  title: 'Sor',
  subtitle:
    'Kayıtlarınızı kendi cümlelerinizle sorun. Yanıt; oturumlarınızdan, hatalarınızdan ve taleplerinizden okunur, ezberden söylenmez.',
  examplesTitle: 'Şunlardan birini deneyin',
  examples: [
    'ayse@example.com son bir ayda kaç kez hata aldı?',
    'Bu hafta en çok zorlanan kullanıcılar kimler?',
    'Şu anda en sık görülen hata hangisi ve kimleri etkiledi?',
    'Dün ödeme adımında vazgeçen oturumları göster.',
  ],
  placeholder: 'Bir kullanıcı, bir hata ya da bir hafta sorun…',
  send: 'Sor',
  thinking: 'Verileriniz okunuyor…',
  writing: 'Yanıt yazılıyor…',
  workedFrom: 'Şuradan okudu:',
  failed: 'Soru yanıtlanamadı. Tekrar deneyin ya da Yönetim → AI ve Modeller’i kontrol edin.',
  exhausted:
    'Bu yanıt eksik: soru, tek seferde yapılabilecekten fazla sorgu gerektirdi. Soruyu daraltıp yeniden sorun.',
  scope:
    'Yalnızca bu şirketin verisine, yalnızca kendi rolünüzün izin verdiği kadar erişilir. Yanıtlar hatalı olabilir; her yanıtın altındaki araçlar gerçekten okuduklarıdır.',
  history: 'Sohbetler',
  newChat: 'Yeni sohbet',
  noHistory: 'Sorularınız burada saklanır, yalnızca siz görürsünüz.',
  delete: 'Sohbeti sil',
  deleteConfirm: 'Bu sohbet silinsin mi? Geri alınamaz.',
  notFound: 'Bu sohbet artık yok.',
  tools: {
    list_projects: 'Projeler listeleniyor',
    search_sessions: 'Oturumlar aranıyor',
    user_activity: 'Kullanıcı etkinliği okunuyor',
    get_session: 'Oturum açılıyor',
    get_session_steps: 'Oturum adımları okunuyor',
    most_frustrated_sessions: 'Zorlanan oturumlar bulunuyor',
    list_error_groups: 'Hatalar listeleniyor',
    get_error_group: 'Hata açılıyor',
    list_tickets: 'Talepler listeleniyor',
    get_ticket: 'Talep açılıyor',
    create_ticket: 'Talep oluşturuluyor',
    analytics_overview: 'Analitik okunuyor',
  },
};

export const ask = { en, tr };
